<template>
 <Popup v-model="isOpen">
        <template #content>
        <div id="update_status">
            <div class="inner">
              <h3 v-if="activeContract.name"></h3>
              <iframe style="border: none;" :src="activeContract.link" height="1000" width="100%" ></iframe>
            </div>
        </div>
        </template>
       <template #actions>
        <a class="md-primary" @click="isOpen = false;activeContract.isApprove = true">אישור החוזה</a> 
        <a class="md-primary" @click="isOpen = false">סגירה</a> 
      </template>
    </Popup>
  <div id="existing_details_apply">
    <div class="card part_1">
      <div class="pic_text_container">
        <div class="pic" :style="'background-image: url(' + item?.user_pic_parsed + ');'"></div>
        <div class="text">
          <p>יוזם המכרז</p>
          <p class="lawyer_name" v-text="item.user_name"></p>
        </div>
      </div>
      <div class="data_fields_container">
        <li class="data_container">
            <h5>סוג המכרז</h5>
            <div v-text="item.is_open === '1' ? 'פתוח' : 'סגור'"></div>
        </li>
        <li class="data_container">
            <h5>סוג הפרוייקט</h5>
            <div v-text="item.type_parse"></div>
        </li>
        <li class="data_container">
          <h5>נפתח תיק במנהלת</h5>
          <div><span class="icon" :class="item.is_file_opened_in_administration ? 'check_icon' : 'close_icon'"></span></div>
        </li>
        
        <li class="data_container">
          <h5>מפקח בפרויקט</h5>
          <div><span class="icon" :class="item.is_supervisor_in_project ? 'check_icon' : 'close_icon'"></span></div>
        </li>
        <li class="data_container">
            <h5>סטטוס</h5>
            <div v-text="item.status_parse"></div>
        </li>
        <li class="data_container">
            <h5>מיזם חשוף</h5>
            <div><span class="icon" :class="item.is_names_open ? 'check_icon' : 'close_icon'"></span></div>
        </li>
        <div class="address_container">
          <li class="data_container">
              <h5>שם המתחם</h5>
              <div v-text="item.name"></div>
          </li>
        </div>

        <li class="data_container">
            <h5>בניינים</h5>
            <div v-text="item.buildings.length"></div>
        </li>
        
        <li class="data_container">
            <h5>יחידות קיימות</h5>
            <div v-text="item.num_apartments"></div>
        </li>
        
        <li class="data_container" v-if="item.main_file_parsed">
            <h5>מידע תכנוני</h5>
            <div>
              <a :href="item.main_file_parsed" target="_blank">צפייה בתיק</a>
            </div>
        </li>
        
        <li class="data_container">
            <h5>מועד סיום המכרז</h5>
            <div v-text="item.date_end"></div>
        </li>
      </div>
    </div>
    <div class="card directorate" v-if="item.is_file_opened_in_administration">
      <h4>דבר העירייה / מנהלת</h4>
      <div class="text_con" v-text="get_word('mnhalet_text', true)"></div>
      <a :href="item.directorate_file_parsed" target="_blank">צפייה בתיק</a>
    </div>
    <div class="card part_2 tabs_card">
      <div class="head">
        <ul class="building_container nav_tabs">
          <li @click="activeBuilding = building" :class="{active: activeBuilding.id === building.id}"  v-for="(building, i) in item.buildings" :key="i">
            <span v-text="'בניין '+ building.number"></span>
          </li>
        </ul>
      </div>
      <div class="content" v-if="activeBuilding">
        <div id="main_building" v-if="activeBuilding">
          <div class="building_details">
            <ul class="data_fields_container">
                <div class="data_1">
                  <li class="data_container">
                      <h5>כתובת</h5>
                      <div>
                          <span v-text="activeBuilding.address_parsed"></span>
                      </div>
                  </li>
                  
                  <li class="data_container">
                      <h5>גוש</h5>
                      <div>
                          <span v-text="activeBuilding.gosh"></span>
                      </div>
                  </li>
                  <li class="data_container">
                      <h5>חלקה</h5>
                      <div>
                          <span v-text="activeBuilding.helka"></span>
                      </div>
                  </li>
                  <li class="data_container">
                      <h5>גודל שטח</h5>
                      <div>
                          <span v-text="activeBuilding.helka_property"></span>
                      </div>
                  </li>
                  <li class="data_container">
                      <h5>קיימת הפקעה</h5>
                      <div><span class="icon" :class="activeBuilding.is_hafkaa ? 'check_icon' : 'close_icon'"></span></div>
                  </li>
                  <li class="data_container">
                      <h5>בית משותף</h5>
                      <div><span class="icon" :class="activeBuilding.is_join_house ? 'check_icon' : 'close_icon'"></span></div>
                  </li>
                </div>
                <div class="data_2">
                  <li class="data_container">
                      <h5>הערה</h5>
                      <div>
                          <span v-text="activeBuilding.note"></span>
                      </div>
                  </li>
                  <li class="data_container">
                      <h5>מסמכי בית משותף</h5>
                      <div>
                        <li v-for="doc in activeBuilding.shared_house_documents" :key="doc.id">
                          <a :href="doc.url" class="doc_link" target="_blank">{{doc.name}} <i class="fas fa-external-link-alt"></i></a>
                        </li>
                      </div>
                  </li>
                  <li class="data_container">
                      <h5>מספר קומות</h5>
                      <div>
                        <span v-if="activeBuilding && activeBuilding.floors" v-text="activeBuilding.floors.length"></span>
                      </div>
                  </li>
                </div>
                <div class="data_3">
                    <li v-if="activeBuilding.ttl_garden > 0" class="data_container">
                      <h5 >דירות גן</h5>
                      <div>
                        <span v-text="activeBuilding.ttl_garden"></span>
                      </div>
                    </li>
                    <li v-if="activeBuilding.ttl_roof > 0" class="data_container">
                      <h5 >דירות גג</h5>
                      <div>
                        <span v-text="activeBuilding.ttl_roof"></span>
                      </div>
                    </li>
                      <li class="data_container">
                        <h5>יחידות</h5>
                        <div>
                          <span  v-text="activeBuilding.num_apartments"></span>
                        </div>
                      </li>
                    <template v-if="activeBuilding.more_fields">
                  <li v-for="fel in activeBuilding.more_fields" :key="fel.id" class="data_container">
                    <h5 v-text="fel.title"></h5>
                    <div>
                       <span  v-text="fel.ttl"></span>
                    </div>
                  </li>
                </template>
                <template v-if="activeBuilding.properties">
                  <li v-for="fel in activeBuilding.properties" :key="fel.id" class="data_container">
                    <h5 v-text="fel.name"></h5>
                    <div>
                       <span  v-text="fel.count"></span>
                    </div>
                  </li>
                </template>
                </div>
                
                
                
                
            </ul>
            <div class="gallery_container">
              <Swiper :modules="modules"  :loop="true" :slidesPerView="1"  >
                <SwiperSlide v-for="(pic,z) in activeBuilding.gallary"  :key="z">
                       <div class="pic" :style="bg(pic.url)"></div>
                </SwiperSlide>
            </Swiper>
            </div>
          </div>
        </div>

        <ul class="floors_container">
          <floor :floor="floor" v-for="floor in activeBuilding.floors" :key="floor.id" />
        </ul>

        <div v-if="state === 'edit'" class="card_b sign_section"  :class="{active: expntionBoxs.includes('sign_section')}">
          <div class="head">
            <div class="text_container">
              <h3>חתימה על מסמכים</h3>
              <p>יש למלא את הפרטים ולחתום בצורה דיגיטלית</p>
            </div>
            <div class="arrow_headers">
                <div class="icon" @click="toggleBox('sign_section')" :class="expntionBoxs.includes('sign_section') ? 'chevron_up_blue_icon' : 'chevron_down_blue_icon'"></div>
            </div>
          </div>
          <div class="content">
            <ul>
              <li v-for="(contract, i) in contracts" :key="i">
                <p v-text="contract.name"></p>
                <div :class="'sign_container '+(contract.isApprove ? 'active' : '')" @click="openPop(contract)" v-if="contract.exist">
                  <div class="icon_text_container">
                    <div class="doc_icon icon"></div>
                    <p v-if="contract.isApprove">הסכם חתום</p>
                    <p v-if="!contract.isApprove">לפתיחה וחתימה</p>
                  </div>
                </div>
                <div class="sign_container not_ex" v-else>
                  <p>לא קיים בפרוייקט</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

      
      </div>
    
    </div>
    <div class="bottom_bar">
      <div class="centered">
        <div class="btn_container" v-if="state === 'edit'">
            <div class="btn" @click="nextStep()">המשך לשלב הבא</div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import floor from '../applyingPrj/floor.vue';
export default {
  props:{
    item:{
      type: Object,
      required: true
    },
    applying_data:{
      type: Object,
      required: false
    },
    state:{
      type: Object,
      required: false
    },
  },
  components: {floor,Swiper, SwiperSlide},
  data() {
    return {
      isOpen:false,
      expntionBoxs: [
        'sign_section'
      ],
      activeContract:{},
      activeBuilding:{},
      contracts: [],
 
    }
  },
  methods: {
    toggleBox(boxName) {
        if (this.expntionBoxs.includes(boxName)) this.expntionBoxs = this.expntionBoxs.filter( str => str != boxName)
        else this.expntionBoxs.push(boxName)
    },
    openPop(item){
      this.isOpen = true;
      this.activeContract = item;
    },
    nextStep(){
      // let approveAll = true;

      // for (let i = 0; i < this.contracts.length; i++) {
      //   if(!this.contracts[i].isApprove && this.contracts[i].exist){
      //     approveAll = false;
      //     break;
      //   }
      // }

      // if(!approveAll){
      //   this.alert('יש לאשר את כל המסמכים');
      // }
      // else{ 
      //   this.$emit('next',this.contracts);
      // }
      
      this.$emit('next',this.contracts);
    },
  },
  mounted() {
    if(this.item.buildings && this.item.buildings[0]) this.activeBuilding = this.item.buildings[0];
    this.contracts.push({name: 'הסכם שכ"ט מול בעלי הדירות', isApprove: false,link: this.item.file_agreement_file ,exist: this.item.file_agreement != '0' ? true : false});
    this.contracts.push({name: 'הסכם מפקח בעלי הדירות', isApprove: false,link: this.item.extra_file_1_file,exist: this.item.extra_file_1 != '0' ? true : false});
    this.contracts.push({name: 'הסכם מארגן / מנהל פרוייקט', isApprove: false,link: this.item.extra_file_2_file,exist: this.item.extra_file_2 != '0' ? true : false});
    this.contracts.push({name: 'הסכם יועץ ביטוח', isApprove: false,link: this.item.extra_file_3_file,exist: this.item.extra_file_3  != '0' ? true : false});
    this.contracts.push({name: 'הסכם שמאי', isApprove: false,link: this.item.extra_file_4_file,exist: this.item.extra_file_4 != '0' ? true : false});
    if (this.state === 'edit') {
      if(this.applying_data && this.applying_data.sign_1 == "1")  this.contracts[0].isApprove = true;
      if(this.applying_data && this.applying_data.sign_2 == "1")  this.contracts[1].isApprove = true;
      if(this.applying_data && this.applying_data.sign_3 == "1")  this.contracts[2].isApprove = true;
      if(this.applying_data && this.applying_data.sign_4 == "1")  this.contracts[3].isApprove = true;
      if(this.applying_data && this.applying_data.sign_5 == "1")  this.contracts[4].isApprove = true;
    }
    
  },
  
  
}
</script>

<style lang="scss" scoped>
  .bottom_bar{
    position: fixed; bottom: 0; left: 0; right: 0; background: #fff; padding: 20px; border-top: 1px solid var(--pageBG);
    .centered{
     
      display: flex; justify-content: flex-end; align-items: center; gap: var(--gap_small);

    }
  }
#existing_details_apply { display: flex; flex-direction: column; gap: var(--gap_mid);
  .part_1 { display: flex; gap: var(--gap_big); padding: var(--gap_small); border-radius: var(--radius_x);
    .pic_text_container { flex: 2; display: flex; flex-direction: column; justify-content: center; padding: 30px; border: var(--pageBG) 1px solid; background: var(--gray); gap: 16px; border-radius: 32px;
        .pic {width: 100%; aspect-ratio: 16/9;border-radius: 12px;background: #fff; background-size: contain; background-position: center; background-repeat: no-repeat;  }
        .text { display: flex; flex-direction: column; 
            p {color: var(--text_s); font-size: var(--h5); font-weight: 500; }
            .lawyer_name {color: var(--btn_color); font-size: var(--h5); font-weight: 700;}
        }
    }
    .data_fields_container { flex: 8; padding:  var(--gap_big); display: grid; grid-template-columns: repeat(6, 1fr); grid-template-rows: repeat(2, 1fr); gap: var(--gap) var(--gap_big);
      li {
        h5 {white-space: nowrap;}
      }
      &>div:first-of-type { grid-area: 1 / 1 / 2 / 3; display: flex;
        li {flex: 1;
          
        }
      }
      &>div:last-of-type { grid-area: 2 / 1 / 3 / 3; }
    }
  }
  .directorate { display: flex; gap: var(--gap_big);
    h4, a { white-space: nowrap; align-content: center; }
    a {     color: var(--dark_blue);
    font-size: 18px;
    font-weight: 600;}
  }
  .part_2 {
    .content { display: flex; flex-direction: column; gap: var(--gap_big);
    #main_building { border: 1px solid var(--pageBG); border-radius: var(--radius); padding: 20px 40px; }
      .building_details { 
      &{    display: flex; gap: 40px;}
       .data_fields_container { flex: 8; display: flex;flex-direction: column; gap: var(--gap_big);
          &>div { display: flex; flex-wrap: wrap; justify-content: space-between; gap: var(--gap); 
            li { }
          }
          .data_3 { 
            // &>div { display: flex; justify-content: space-between; flex: 1;}
            // .right { position: relative; 
            //   &::after { content: ""; position: absolute; left: calc(var(--gap_xbig)* -1); top: 0; bottom: 0; width: 1px; background: var(--pageBG); }
            // }
          }
        // &>div:first-of-type { grid-area: 1 / 1 / 2 / 3; display: flex;
        //   li {flex: 1;}
        // }
        // &>div:last-of-type { grid-area: 2 / 1 / 3 / 3; }
      }
      .gallery_container{flex:4;position: relative;;
      .swiper {max-width:250px ;}
        .pic{height: 250px;/* width: 100px; */background-size: cover;}
      }
    }
      .floors_container { display: flex; flex-direction: column; gap: var(--gap); }
      .sign_section {
        &:has(.icon_text_container) {  }
        &.active { background: linear-gradient(196.79deg, #FFFFFF 6.85%, #F5F9FA 60.06%, rgba(231, 240, 243, 0.89) 91.99%); border: 2px solid var(--Border-card-sections, #E7F0F3) }
        .content {
          ul {display: flex; justify-content: space-between; gap: var(--gap_big);
            li { display: flex; flex: 1; flex-direction: column; gap: var(--gap);
              &>p {font-weight: 500; font-size: var(--h5); color: var(--dark_blue);}
              .sign_container { display: flex; justify-content: center; align-items: center; width: 100%; aspect-ratio: 16/10; border: 2px dashed var(--pageBG); border-radius: var(--radius_md);  
                
                &.not_ex {
                  p { color: var(--ligth_color); }
                }
                &.active { background: linear-gradient(196.79deg, #FFFFFF 6.85%, #F5F9FA 60.06%, rgba(231, 240, 243, 0.89) 91.99%); border: 2px solid var(--Border-card-sections, #E7F0F3); 
                  p { font-weight: 500; font-size: var(--h5); color: var(--dark_blue);}
                }
                .icon_text_container { display: flex; gap: var(--gap_small); flex-direction: column;  align-items: center; justify-content: center;}
                
              }
            }
          }
        }
      }
    }
  }
  .btn_container { align-self: flex-end; }
}
.doc_link{
  color: var(--dark_blue);
  font-size: var(--h5);
  font-weight: 500;
  text-decoration: underline;
  svg{
    width: 16px;
    height: 16px;
    color: var(--dark_blue);
    margin-right: var(--gap_small);
  }
  
}
@media (max-width: 768px) {
  #existing_details_apply {
    padding:0px;
    .part_1 {
      flex-direction: column;
      .data_fields_container {
        grid-template-columns: repeat(2, 1fr) !important;
        grid-template-rows: repeat(6, auto) !important;
        padding:0 0px;
        width: 80%;
        align-self: center;
        gap: 15px;

        .data_container{
          flex-direction: column;
          align-items: flex-start;
          gap: 8px;
        }
         h5{
                font-weight: 700; 
            }
        &>div:first-of-type {
          grid-area: auto !important;
        }
        &>div:last-of-type {
          grid-area: auto !important;
        }
      }
      .pic_text_container { 
        flex: 2; 
        display: flex;
         flex-direction: column;
          justify-content: center; 
          text-align: center;
          align-items: center;
          padding: 30px; 
          border: var(--pageBG) 1px solid; 
          background: var(--gray); 
          gap: 16px; 
          border-radius: 32px;
        .pic {
          width: 80%; 
          align-self: center;
          aspect-ratio: 16/9;
          border-radius: 12px;
          background: #fff;
          background-size: contain;
          background-position: center; 
          background-repeat: no-repeat;
            }
        .text { 
          display: flex; 
          flex-direction: column; 
            p {
              color: var(--text_s); 
              font-size: var(--h5); 
              font-weight: 700; 
              
            }
            .lawyer_name {
              color: var(--btn_color); 
              font-size: var(--h5); 
              font-weight: 700;
            }
        }
        
    }
    }
   
    
  }
   .part_2 {
        max-width: 100%;
        flex-direction: column;
        padding:0 ;
       margin-bottom: 80px;

      .content{
        padding:10px; 
        
      }
       .nav_tabs {
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        padding:10px 0;
       
      }
      .building_details {
        flex-direction: column;
        width: 90%;

        .card_b{
          
        }
        .content {
          flex-direction: column;
        }
        .galery_fields_container{
          flex-direction: column;
        }
        
       
        .gallery_container {
          .swiper {
            max-width: 100%;
          }
        }
      
      }
      :deep( .main_floor .head ){
        padding: 0 0 !important;
        .fields_container{
        width:100%;
        justify-content: center;
         li{
          flex-direction: row ;
          height: fit-content;
           width: fit-content;
           justify-content: space-evenly;
          label{
            width: fit-content;
          }
        }
        }
       
        
      }
      .sign_section{
        .head{
          flex-direction: column;
          gap: var(--gap_small);

          .text_container{
            flex-direction: column;
            gap: 2px;
            width: 100%;

            p{
              font-size: 16px;
            }
          }
          
        }
        ul{
          flex-wrap: wrap;
          align-items: flex-end;
          gap:var(--gap_small) !important;
          
          li{
            flex-direction: row ;
            height: fit-content;
            max-width: 45% ;
             min-width:40%;
             justify-content: space-evenly;
             gap:var(--gap_small) !important;
            p{
              font-size: 16px !important;
              width: fit-content;
            }
            .sign_container{
              padding:10px;
              
            }
          }
        }
        
        
      }
      
    }
     .bottom_bar{
      position: fixed;  bottom: 0; left: 0; right: 0; background: #fff; padding: 10px; border-top: 1px solid var(--pageBG);
      .centered{
        display: flex; justify-content: center; align-items: center; gap: var(--gap_small); 
      }
      .btn{
        min-width: 80%;
        font-size: 16px;
        line-height: 1;
        height: fit-content;
        padding: 12px 25px;
        
        justify-self: center;
        
      }

      .btn_container { 
        justify-content: center;
        align-items: center;
        min-width: 100%;
        
      }
    }

        
     
}

</style>